export default "__VITE_ASSET__BTUNCY5Z__"